import { render, staticRenderFns } from "./GetFeeDetails.vue?vue&type=template&id=627b4a4c&"
import script from "./GetFeeDetails.vue?vue&type=script&lang=js&"
export * from "./GetFeeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports